/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { useCallback, useEffect, useMemo, useState } from "react";
import { API, get, QuestionRiskOptions } from "../../../../config";
import { Button } from "../../../../components/ui/button";
import { useTheme } from "next-themes";
import { useOrganization } from "../../../../lib/context/OrganisationContext";
import { useStepper } from "../../../../components/ui/stepper";

export function SummaryStep({
  sections,
  setLoading,
  analysis,
  sectionType,
  handleFinish,
  disableSubmit,
  fetchAnalysis,
}) {
  const { organizationData } = useOrganization();
  const { nextStep, prevStep, activeStep, isLastStep } = useStepper();

  useEffect(() => {
    // if (sections?.length > 1 && (!analysis || analysis?.length === 0)) {
    if (isLastStep) {
      fetchAnalysis(sections);
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { theme, systemTheme } = useTheme();
  const [chartData, setChartData] = useState([]);
  const [needleData, setNeedleData] = useState([]);

  const fetchConditions = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await get(
        `${API.GET_CONDITIONS}?page=1&limit-1&section_type=${sectionType}&organization_id=${organizationData?.organizationId}`,
      );
      setLoading(false);
      let chartDatas = [];
      let needleDatas = {};
      let counter = 0;
      for (let i = 0; i < data.data.data?.length; i++) {
        let riskLevel = data.data.data[i]?.risk
          ? QuestionRiskOptions?.find(
              (item) => item.value === data.data.data[i]?.risk,
            )?.label
          : "";
        chartDatas.push({
          name: riskLevel,
          value: 1,
          color: data.data.data[i]?.color,
        });
        if (!(riskLevel in needleDatas)) {
          needleDatas[riskLevel] = counter + 0.5;
          counter += 1; // move to next step (0.5 → 1.5 → 2.5)
        }
      }
      setChartData(chartDatas);
      setNeedleData(needleDatas);
    } catch (e) {
      // setConditions([]);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchConditions();
  }, [fetchConditions]);

  const yesCounts = useMemo(
    () =>
      sections?.map(
        (s) => s.questions.filter((q) => q.answer === "Yes").length,
      ),
    [sections],
  );

  /** ---------- Gauge Chart Setup ---------- */

  const getNeedleValue = () =>
    needleData?.[
      QuestionRiskOptions?.find((item) => item.value === analysis?.risk)?.label
    ] || 0;
  const cx = 80,
    cy = 80,
    iR = 60,
    oR = 80;

  // Needle renderer
  const renderNeedle = (value, data, cx, cy, iR, oR, color) => {
    const total = data.length;
    const angle = 180 * (1 - value / total);
    const length = (iR + oR) / 2;
    const radian = Math.PI / 180;
    const x = cx + length * Math.cos(-angle * radian);
    const y = cy + length * Math.sin(-angle * radian);

    return (
      <>
        <circle cx={cx} cy={cy} r={5} fill={color} stroke="none" />
        <line
          x1={cx}
          y1={cy}
          x2={x}
          y2={y}
          stroke={color}
          strokeWidth={3}
          strokeLinecap="round"
        />
      </>
    );
  };

  return (
    <div className="items-center">
      <h2 className="text-lg font-semibold">Final Summary</h2>
      {/* Section Summary Cards */}
      <div className="flex items-start mt-2 gap-4">
        <div className="flex items-center gap-4 w-[350px] flex-wrap">
          {yesCounts?.map((count, idx) => (
            <div className="bg-white dark:bg-muted shadow rounded-lg p-4 text-center max-w-[150px] max-h-[90px]">
              <p className="font-semibold">Section {idx + 1}</p>
              <p key={idx} className="text-lg">
                {count} / {sections[idx]?.questions.length || 0} Yes
              </p>
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-medium">Risk Level:</span>{" "}
              {
                QuestionRiskOptions?.find(
                  (item) => item.value == analysis?.risk,
                )?.label
              }{" "}
              <div
                style={{
                  background: analysis?.color,
                }}
                className="h-5 w-5 rounded-full"
              />
            </div>
            <p className="text-sm italic">{analysis?.risk_action}</p>
          </div>
          {/* Risk Pie with Needle */}
          <div className="w-48 h-32">
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  dataKey="value"
                  startAngle={180}
                  endAngle={0}
                  data={chartData}
                  paddingAngle={5}
                  cx={cx}
                  cy={cy}
                  innerRadius={iR}
                  outerRadius={oR}
                  stroke="none"
                >
                  {chartData.map((entry, index) => (
                    <Cell key={index} fill={entry.color} />
                  ))}
                </Pie>
                {renderNeedle(
                  getNeedleValue(),
                  chartData,
                  cx,
                  cy,
                  iR,
                  oR,
                  (systemTheme === "dark" && theme === "system") ||
                    theme === "dark"
                    ? "#fff"
                    : "#000",
                )}
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      <div className="flex justify-end gap-3">
        {activeStep > 0 && (
          <Button variant="secondary" onClick={prevStep}>
            Previous
          </Button>
        )}
        <Button
          onClick={() => {
            handleFinish();
          }}
          disabled={disableSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
}
